<div class="change-signature-dialog">
    <h1 mat-dialog-title id="signature-title">Document Signing Set Up</h1>
    <ng-container *ngIf="user?.needProfileUpdate">
        <h3 style="font-weight: bold; margin-top: 0; color: var(--grey)">
            Please type your legal name and use your mouse, finger or a stylus to create your digital signature and initials so you can sign documents
            electronically.
            <b>Please add your signature and initials close to the corresponding guidelines, so they will show up correctly on the documents.</b>
        </h3>
    </ng-container>
    <div>
        <app-signature-form
            [ids]="['signature-edit', 'initials-edit']"
            [user]="user"
            [canEdit]="canEditSignatures"
            [hideCancelButton]="true"
            [hideExplanation]="true"
            [hideButton]="false"
            (outEvent)="eventHandler($event)"
        >
        </app-signature-form>
    </div>
</div>
